module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pegasus/peg_vis-6b43ec94d9c7a52f371316da1966d367.jpg";